<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    let LoadingEle = document.getElementById("Loading");
    if (LoadingEle) {
      document.body.removeChild(LoadingEle);
    }
  }
};
</script>

<style lang="scss">
</style>
